// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Cache from "../data/Cache.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as HorBarChart from "../common/HorBarChart.bs.js";
import * as Tc2OtherTab from "../tc2/Tc2OtherTab.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as StatsOtherTab from "./StatsOtherTab.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as UnitItemsTable from "../units/UnitItemsTable.bs.js";
import Tab from "@mui/material/Tab";
import * as DoubleHorBarChart from "../common/DoubleHorBarChart.bs.js";
import Tabs from "@mui/material/Tabs";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import * as Tc2RegionDistributionChart from "../tc2/Tc2RegionDistributionChart.bs.js";

function UnitOverview$Overview(Props) {
  var unitStats = Props.unitStats;
  ScreenAtom.use(undefined);
  var t = Translation.useT(/* Common */0);
  return React.createElement("div", {
              className: "flex gap-8 md:flex-row flex-wrap md:gap-12 p-4"
            }, React.createElement("div", undefined, React.createElement("div", {
                      className: "leading-none pb-2"
                    }, "Stats"), React.createElement("div", {
                      className: "grid gap-2 font-montserrat font-medium text-sm leading-none grid-cols-[minmax(auto,85px),auto] grid-rows-[repeat(4,14px)]"
                    }, React.createElement("div", {
                          className: "text-white2"
                        }, t("Games") + ":"), React.createElement("div", {
                          className: "font-semibold"
                        }, T.humanReadableCount(unitStats.base.count)), React.createElement("div", {
                          className: "text-white2"
                        }, t("Play rate") + ":"), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.toFixed(undefined, unitStats.base.rate)), React.createElement("div", {
                          className: "text-white2"
                        }, t("Avg. place") + ": "), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.toFixed(undefined, unitStats.base.place)), React.createElement("div", {
                          className: "text-white2"
                        }, t("Top 4") + ": "), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.formatPct3(unitStats.base.top4)), React.createElement("div", {
                          className: "text-white2"
                        }, t("Win") + ": "), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.formatPct3(unitStats.base.won)))), React.createElement("div", undefined, React.createElement("div", {
                      className: "leading-none pb-2"
                    }, t("Star level distribution")), React.createElement(DoubleHorBarChart.make, {
                      data: Belt_Array.map(Belt_Array.keep(unitStats.starLevelData, (function (dp) {
                                  return dp.id < 5;
                                })), (function (dp) {
                              return [
                                      String(dp.id),
                                      Global.f(dp.count) / Global.f(unitStats.base.count),
                                      dp.place
                                    ];
                            }))
                    })), React.createElement("div", undefined, React.createElement("div", {
                      className: "leading-none pb-2"
                    }, t("Placement distribution")), React.createElement(HorBarChart.make, {
                      data: Belt_Array.mapWithIndex(unitStats.placeDistribution, (function (idx, count) {
                              return [
                                      String(idx + 1 | 0),
                                      count
                                    ];
                            }))
                    })), React.createElement("div", undefined, React.createElement("div", {
                      className: "leading-none pb-2"
                    }, t("Item count distribution")), React.createElement(DoubleHorBarChart.make, {
                      data: Belt_Array.map(unitStats.itemCountData, (function (dp) {
                              return [
                                      String(dp.id),
                                      Global.f(dp.count) / Global.f(unitStats.base.count),
                                      dp.place
                                    ];
                            }))
                    })));
}

var Overview = {
  make: UnitOverview$Overview
};

function UnitOverview$Trends(Props) {
  var unitStats = Props.unitStats;
  var match = React.useState(function () {
        return [
                "All",
                "euw1",
                "na1",
                "kr"
              ];
      });
  var selectedRegions = match[0];
  var t = Translation.useT(/* Common */0);
  var regionDateStats = Belt_Array.keep(unitStats.regionDateStats, (function (dp) {
          return selectedRegions.includes(dp.id[0]);
        }));
  return React.createElement("div", {
              className: "flex flex-col items-center px-5"
            }, React.createElement("div", {
                  className: "flex flex-col md:flex-row pt-4 gap-5"
                }, React.createElement("div", undefined, React.createElement("div", {
                          className: "text-lg leading-none pb-2 font-montserrat font-medium"
                        }, t("Region Distribution")), React.createElement(Tc2RegionDistributionChart.make, {
                          groupPr: unitStats.base.rate,
                          groupPlace: unitStats.base.place,
                          regionDistribution: Belt_Array.map(unitStats.regionStats, (function (dp) {
                                  return [
                                          dp.id,
                                          dp.rate,
                                          dp.place
                                        ];
                                })),
                          selectedRegions: selectedRegions,
                          barWidth: 150
                        })), React.createElement("div", {
                      className: "flex gap-5 flex-col sm:flex-row justify-around pb-3"
                    }, React.createElement("div", undefined, React.createElement("div", {
                              className: "text-lg leading-none pl-[28px] pb-2 font-montserrat font-medium"
                            }, t("Play Rate")), React.createElement(StatsOtherTab.DatePlayRateStats.make, {
                              dateStats: unitStats.dateStats,
                              regionDateStats: regionDateStats,
                              selectedRegions: selectedRegions,
                              totCount: unitStats.base.count,
                              chartWidth: 225,
                              chartHeight: 200
                            })), React.createElement("div", {
                          className: "pt-4 sm:pt-0"
                        }, React.createElement("div", {
                              className: "text-lg leading-none pl-[28px] pb-2 font-montserrat font-medium"
                            }, t("Avg. Place")), React.createElement(StatsOtherTab.DatePlaceStats.make, {
                              dateStats: unitStats.dateStats,
                              regionDateStats: regionDateStats,
                              selectedRegions: selectedRegions,
                              chartWidth: 225,
                              chartHeight: 200
                            })))), React.createElement("div", {
                  className: "py-2"
                }, React.createElement(Tc2OtherTab.RegionSelect.make, {
                      selectedRegions: selectedRegions,
                      setSelectedRegions: match[1]
                    })));
}

var Trends = {
  make: UnitOverview$Trends
};

function UnitOverview$Counters(Props) {
  var unitStats = Props.unitStats;
  var inContext = Props.inContext;
  var screenSize = ScreenAtom.use(undefined);
  var avgWr = Belt_Array.reduce(unitStats.unitMatchups, 0, (function (acc, v) {
          return acc + v.winrate;
        })) / unitStats.unitMatchups.length;
  var avgWr$1 = Belt_Array.reduce(unitStats.traitMatchups, 0, (function (acc, v) {
          return acc + v.winrate;
        })) / unitStats.traitMatchups.length;
  var avgWr$2 = Belt_Array.reduce(unitStats.unitMatchups, 0, (function (acc, v) {
          return acc + v.winrate;
        })) / unitStats.unitMatchups.length;
  var avgWr$3 = Belt_Array.reduce(unitStats.traitMatchups, 0, (function (acc, v) {
          return acc + v.winrate;
        })) / unitStats.traitMatchups.length;
  return React.createElement("div", {
              className: "block sm:flex"
            }, React.createElement(ContentSection.make, {
                  level: inContext ? 2 : 1,
                  className: "flex-1",
                  title: "Strong Against",
                  children: null
                }, React.createElement("h6", {
                      className: "text-lg pb-3 pt-1 font-medium"
                    }, "Units"), React.createElement("div", {
                      className: "grid gap-2 md:gap-3 grid-cols-[repeat(auto-fill,minmax(42px,1fr))] md:grid-cols-[repeat(auto-fill,minmax(52px,1fr))]"
                    }, Belt_Array.map(T.getBestMatchups(unitStats.unitMatchups, screenSize === /* Sm */4 ? 5 : 6, avgWr), (function (m) {
                            return React.createElement(UnitImage.make, {
                                        unitId: m.unitId,
                                        size: 42,
                                        sizeMd: 52,
                                        key: m.unitId
                                      });
                          }))), React.createElement("h6", {
                      className: "text-lg pb-2 pt-8 font-medium"
                    }, "Traits"), React.createElement("div", {
                      className: "grid gap-2 md:gap-3 grid-cols-[repeat(auto-fill,minmax(42px,1fr))] md:grid-cols-[repeat(auto-fill,minmax(52px,1fr))]"
                    }, Belt_Array.map(T.getBestMatchups(unitStats.traitMatchups, screenSize === /* Sm */4 ? 5 : 6, avgWr$1), (function (m) {
                            return React.createElement(TraitTooltip.make, {
                                        trait: m.traitId,
                                        rank: m.traitTier,
                                        children: React.createElement(TraitImage.PlainIcon2.make, {
                                              traitId: m.traitId,
                                              rank: m.traitTier,
                                              size: 40,
                                              sizeMd: 50
                                            }),
                                        key: m.traitId + String(m.traitTier)
                                      });
                          })))), React.createElement(ContentSection.make, {
                  level: inContext ? 2 : 1,
                  className: "flex-1 mt-4 sm:mt-0 sm:ml-4",
                  title: "Weak Against",
                  children: null
                }, React.createElement("h6", {
                      className: "text-lg pb-3 pt-1 font-medium"
                    }, "Units"), React.createElement("div", {
                      className: "grid gap-2 md:gap-3 grid-cols-[repeat(auto-fill,minmax(42px,1fr))] md:grid-cols-[repeat(auto-fill,minmax(52px,1fr))]"
                    }, Belt_Array.map(T.getWorstMatchups(unitStats.unitMatchups, screenSize === /* Sm */4 ? 5 : 6, avgWr$2), (function (m) {
                            return React.createElement(UnitImage.make, {
                                        unitId: m.unitId,
                                        size: 42,
                                        sizeMd: 52,
                                        key: m.unitId
                                      });
                          }))), React.createElement("h6", {
                      className: "text-lg pb-2 pt-8 font-medium"
                    }, "Traits"), React.createElement("div", {
                      className: "grid gap-2 md:gap-3 grid-cols-[repeat(auto-fill,minmax(42px,1fr))] md:grid-cols-[repeat(auto-fill,minmax(52px,1fr))]"
                    }, Belt_Array.map(T.getWorstMatchups(unitStats.traitMatchups, screenSize === /* Sm */4 ? 5 : 6, avgWr$3), (function (m) {
                            return React.createElement(TraitTooltip.make, {
                                        trait: m.traitId,
                                        rank: m.traitTier,
                                        children: React.createElement(TraitImage.PlainIcon2.make, {
                                              traitId: m.traitId,
                                              rank: m.traitTier,
                                              size: 40,
                                              sizeMd: 50
                                            }),
                                        key: m.traitId + String(m.traitTier)
                                      });
                          })))));
}

var Counters = {
  make: UnitOverview$Counters
};

function UnitOverview$Inner(Props) {
  var inContextOpt = Props.inContext;
  var unitStats = Props.unitStats;
  var starLevel = Props.starLevel;
  var onChangeStarLevel = Props.onChangeStarLevel;
  var scrollRef = Props.scrollRef;
  var inContext = inContextOpt !== undefined ? inContextOpt : false;
  var screenSize = ScreenAtom.use(undefined);
  ScreenAtom.isMobile(screenSize);
  ApertureCtx.useValue(undefined);
  var match = React.useState(function () {
        return /* Overview */0;
      });
  var setTab = match[1];
  var tab = match[0];
  var t = Translation.useT(/* Common */0);
  var tmp = {
    inContext: inContext,
    unitStats: unitStats,
    starLevel: starLevel === 0 ? undefined : starLevel
  };
  if (scrollRef !== undefined) {
    tmp.scrollRef = Caml_option.valFromOption(scrollRef);
  }
  return React.createElement("div", {
              className: "flex flex-col gap-4"
            }, React.createElement(ContentSection.make, {
                  level: inContext ? 2 : 1,
                  className: "text-sm sm:text-base",
                  children: null,
                  noPadding: true
                }, React.createElement("div", {
                      className: "flex justify-start pt-2 max-w-[100vw]"
                    }, React.createElement(Tabs, {
                          children: null,
                          value: tab,
                          onChange: (function (param, t) {
                              return Curry._1(setTab, (function (param) {
                                            return t;
                                          }));
                            })
                        }, React.createElement(Tab, {
                              label: t("Overview"),
                              value: /* Overview */0
                            }), React.createElement(Tab, {
                              label: t("Trends"),
                              value: /* Trends */1
                            })), React.createElement("div", {
                          className: "ml-4 gap-2 flex items-center"
                        }, React.createElement("div", {
                              className: "font-montserrat font-medium"
                            }, "Star level:"), React.createElement(Select, {
                              value: starLevel,
                              onChange: (function (e) {
                                  return Curry._1(onChangeStarLevel, e.target.value);
                                }),
                              variant: "standard",
                              children: null
                            }, React.createElement(MenuItem, {
                                  value: 0,
                                  children: "Any"
                                }), React.createElement(MenuItem, {
                                  value: 1,
                                  children: "★"
                                }), React.createElement(MenuItem, {
                                  value: 2,
                                  children: "★★"
                                }), React.createElement(MenuItem, {
                                  value: 3,
                                  children: React.createElement("span", {
                                        className: "text-amber-9"
                                      }, "★★★")
                                })))), tab ? React.createElement(UnitOverview$Trends, {
                        unitStats: unitStats
                      }) : React.createElement(UnitOverview$Overview, {
                        unitStats: unitStats
                      })), React.createElement(UnitItemsTable.make, tmp), unitStats.unitMatchups.length === 0 && unitStats.traitMatchups.length === 0 ? null : React.createElement(UnitOverview$Counters, {
                    unitStats: unitStats,
                    inContext: inContext
                  }));
}

var Inner = {
  make: UnitOverview$Inner
};

function UnitOverview(Props) {
  var inContext = Props.inContext;
  var unitId = Props.unitId;
  var starLevel = Props.starLevel;
  var setStarLevel = Props.setStarLevel;
  var scrollRef = Props.scrollRef;
  var aperture = ApertureCtx.useValue(undefined);
  var unitStats = Cache.useUnitStats2(unitId, starLevel, aperture.queue);
  if (unitStats === undefined) {
    return null;
  }
  var tmp = {
    inContext: inContext,
    unitStats: unitStats,
    starLevel: starLevel,
    onChangeStarLevel: (function (sl) {
        return Curry._1(setStarLevel, (function (param) {
                      return sl;
                    }));
      })
  };
  if (scrollRef !== undefined) {
    tmp.scrollRef = Caml_option.valFromOption(scrollRef);
  }
  return React.createElement(UnitOverview$Inner, tmp);
}

var make = UnitOverview;

export {
  Overview ,
  Trends ,
  Counters ,
  Inner ,
  make ,
  
}
/* T Not a pure module */
